/**
 * @swoft/core-architecture - Official Compatibility Package
 *
 * This package provides backward compatibility for domains using the old
 * @swoft/core-architecture package name. It re-exports everything from
 * the new unified @swoft/core package.
 *
 * Migration Path:
 * OLD: import { AggregateRoot } from '@swoft/core-architecture';
 * NEW: import { AggregateRoot } from '@swoft/core';
 *
 * This compatibility package allows gradual migration without breaking changes.
 */

// Simply re-export everything from @swoft/core
// This ensures maximum compatibility with existing code
export * from '@swoft/core';
